import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _caEventCategories;

import { EEstimationTargets } from '../types';
/**
 * С помощью константы определяем поле category в отправляемой аналитике
 * */

export var caEventCategories = (_caEventCategories = {}, _defineProperty(_caEventCategories, EEstimationTargets.flat, 'EstateCalculator'), _defineProperty(_caEventCategories, EEstimationTargets.house, 'EstateHouseCalculator'), _defineProperty(_caEventCategories, EEstimationTargets.land, 'EstateLandCalculator'), _defineProperty(_caEventCategories, EEstimationTargets.newbuilding, 'EstateCalculatorJK'), _caEventCategories);